module.exports = __webpack_public_path__ + "8e3e0336d8525c0af7b2daf378bf4101.MP3";